import { Toaster } from "@sorcery/ui";
import Head from "next/head";
import type { ReactNode } from "react";
import { Banner } from "../molecules/Banner";
import { Footer } from "./Footer";
import { HeaderDecorator } from "./HeaderDecorator";
import { Modal } from "./Modal";

const DEFAULT_TITLE = "Sorcery: Contested Realm";
const DEFAULT_DESCRIPTION =
  'An "old school" fantasy card game for players with a rich imagination, tactical nerve and an appreciation for hand-painted art.';
const DEFAULT_IMAGE = "https://d27a44hjr9gen3.cloudfront.net/assets/logos/splashlogo.webp";

type PageProps = {
  children: ReactNode;
  title?: string;
  description?: string;
  image?: string;
  hero?: ReactNode;
};

export const Page = ({
  children,
  title = DEFAULT_TITLE,
  description = DEFAULT_DESCRIPTION,
  image = DEFAULT_IMAGE,
  hero,
}: PageProps) => (
  <>
    <Head>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="og:image" content={image} />
      <link rel="icon" href="/favicon.ico" />
    </Head>
    {/* content */}
    <section className="z-0">{hero}</section>
    <main className="relative z-10">
      <Banner />
      <HeaderDecorator />
      <div className="flex min-h-[calc(100vh-4rem)] flex-col justify-between animate-in fade-in">
        <div className="py-8 duration-700 animate-in fade-in">{children}</div>
        <Footer />
      </div>
    </main>
    <Toaster position="bottom-left" closeButton />
    <Modal />
  </>
);
